import service from "@/utils/request";
//学员列表
export interface staffListListData {
  page: number;
  page_size: number;
  key_word?: string;
  on_job?: number;
  is_teach?: number;
}
// 员工列表
export const rolesList = () => {
  return service({
    url: "/api/v1/roles/list",
    method: "get",
  });
};
// 角色详情
export const rolesDetail = (params: { role_id: number }) => {
  return service({
    url: "/api/v1/roles/detail",
    method: "get",
    params,
  });
};
// 获取机构显示菜单选项
export const rolesMenu = () => {
  return service({
    url: "/api/v1/roles/menu",
    method: "get",
  });
};
// 创建角色
export interface rolesCreateData {
  role_name: string;
  describe: string;
  menu_rules: [];
  role_id?: number;
  data_authority: [];
}
//创建角色
export const rolesCreate = (data: rolesCreateData) => {
  return service({
    url: "/api/v1/roles/create",
    method: "post",
    data,
  });
};
//编辑角色
export const rolesModify = (data: rolesCreateData) => {
  return service({
    url: "/api/v1/roles/modify",
    method: "post",
    data,
  });
};
//删除角色
export const rolesDel = (data: { role_id: number }) => {
  return service({
    url: "/api/v1/roles/del",
    method: "post",
    data,
  });
};
